import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=28b92806&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=28b92806&prod&lang=scss&scoped=true"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&id=28b92806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b92806",
  null
  
)

export default component.exports